import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index/index')
		},
		{
			path: '/search/:value',
			name: 'search',
			component: () => import('@/views/search/search')
		},
		{
			path: '/list/:columnId',
			name: 'list',
			component: () => import('@/views/list/list')
		},
		{
			path: '/list/details/:id',
			name: 'listdetails',
			component: () => import('@/views/list/details')
		},
		{
			path: '/zcwj/:columnId',
			name: 'zcwj',
			component: () => import('@/views/zcwj/zcwj')
		},
		{
			path: '/xxgk/:columnId',
			name: 'xxgk',
			component: () => import('@/views/xxgk/xxgk')
		},
		{
			path: '/detail/details/:columnId',
			name: 'detail',
			component: () => import('@/views/detail/details')
		},








		// {
		// 	path: '/ldhd',
		// 	name: 'ldhd',
		// 	component: () => import('@/views/ldhd/ldhd')
		// },
		// {
		// 	path: '/ldhd/newsmore',
		// 	name: 'ldhdnewsmore',
		// 	component: () => import('@/views/ldhd/newsmore')
		// },
		// {
		// 	path: '/ldhd/imgmore',
		// 	name: 'ldhdimgmore',
		// 	component: () => import('@/views/ldhd/imgmore')
		// },
		// {
		// 	path: '/ldhd/details/:id',
		// 	name: 'ldhdsdetails',
		// 	component: () => import('@/views/ldhd/details')
		// },

		// {
		// 	path: '/xxgk/newsmore',
		// 	name: 'xxgknewsmore',
		// 	component: () => import('@/views/xxgk/newsmore')
		// },
		// {
		// 	path: '/xxgk/imgmore',
		// 	name: 'xxgkimgmore',
		// 	component: () => import('@/views/xxgk/imgmore')
		// },
		// {
		// 	path: '/xxgk/details/:id',
		// 	name: 'xxgkdetails',
		// 	component: () => import('@/views/xxgk/details')
		// },
		// {
		// 	path: '/xcxs',
		// 	name: 'xcxs',
		// 	component: () => import('@/views/xcxs/xcxs')
		// },
		// {
		// 	path: '/xcxs/details/:id',
		// 	name: 'xcxsdetails',
		// 	component: () => import('@/views/xcxs/details')
		// },
		// {
		// 	path: '/xwyw',
		// 	name: 'xwyw',
		// 	component: () => import('@/views/xwyw/xwyw')
		// },
		// {
		// 	path: '/xwyw/details/:id',
		// 	name: 'xwywsdetails',
		// 	component: () => import('@/views/xwyw/details')
		// },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js